import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";
import {
  FETCH_JOB_ALERT,
  FETCH_JOB_ALERT_SUCCESS,
  FETCH_JOB_ALERT_FAILED,
  SAVE_JOB_ALERT,
  SAVE_JOB_ALERT_SUCCESS,
  SAVE_JOB_ALERT_FAILED,
  DELETE_JOB_ALERT,
  DELETE_JOB_ALERT_SUCCESS,
  DELETE_JOB_ALERT_FAILED,
  UPDATE_ADD_STATUS_EMPTY,
  FETCH_THANK_YOU,
  FETCH_THANK_YOU_SUCCESS,
  FETCH_THANK_YOU_FAILED,
  FETCH_USER_CVS_FAILED,
  FETCH_USER_CVS_SUCCESS,
  FETCH_USER_CVS,
} from "./actionTypes";
import { getAuthUserToken } from "../../helpers/authToken";

export const updateJobAddStatus = () => (dispatch) => {
  dispatch({
    type: UPDATE_ADD_STATUS_EMPTY,
    payload: null,
  });
};
export const fetchJobAlert = () => (dispatch) => {
  dispatch({
    type: FETCH_JOB_ALERT,
    payload: null,
  });
  http
    .post(
      "user/job-alert",
      doObjToFormData({ token: getAuthUserToken() })
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_JOB_ALERT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_JOB_ALERT_FAILED,
        payload: error,
      });
    });
};

export const saveJobAlert = (formData) => (dispatch) => {
  formData = { ...formData, token: getAuthUserToken() };
  formData = doObjToFormData(formData);

  dispatch({
    type: SAVE_JOB_ALERT,
    payload: null,
  });
  http
    .post("user/save-job-alert", formData)
    .then(({ data }) => {
      if (data.status) {
        toast.success("Job alert saved successfully.", TOAST_SETTINGS);
        dispatch({
          type: SAVE_JOB_ALERT_SUCCESS,
          payload: data,
        });
      } else {
        if (data.validationErrors) {
          toast.error(
            <Text string={data.validationErrors} parse={true} />,
            TOAST_SETTINGS
          );
          dispatch({
            type: SAVE_JOB_ALERT_FAILED,
            payload: null,
          });
        }
      }
    })
    .catch((error) => {
      dispatch({
        type: SAVE_JOB_ALERT_FAILED,
        payload: error,
      });
    });
};

export const deleteJobAlert = (formData) => (dispatch) => {
  formData = { ...formData, token: getAuthUserToken() };
  formData = doObjToFormData(formData);

  dispatch({
    type: DELETE_JOB_ALERT,
    payload: null,
  });
  http
    .post("user/delete-job-alert", formData)
    .then(({ data }) => {
      if (data.status) {
        toast.success("Job alert deleted successfully.", TOAST_SETTINGS);
        dispatch({
          type: DELETE_JOB_ALERT_SUCCESS,
          payload: data,
        });
      } else {
        if (data.validationErrors) {
          toast.error(
            <Text string={data.validationErrors} parse={true} />,
            TOAST_SETTINGS
          );
          dispatch({
            type: DELETE_JOB_ALERT_FAILED,
            payload: null,
          });
        }
      }
    })
    .catch((error) => {
      dispatch({
        type: DELETE_JOB_ALERT_FAILED,
        payload: error,
      });
    });
};

export const fetchThankYou = () => (dispatch) => {
  dispatch({
    type: FETCH_THANK_YOU,
    payload: null,
  });
  http
    .post(
      "user/thank-you",
      doObjToFormData({ token: getAuthUserToken() })
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_THANK_YOU_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_THANK_YOU_FAILED,
        payload: error,
      });
    });
};
export const fetchUserCvs = () => (dispatch) => {
  dispatch({
    type: FETCH_USER_CVS,
    payload: null,
  });
  http
    .post(
      "user/my-cvs",
      doObjToFormData({ token: getAuthUserToken() })
    )
    .then(({ data }) => {
      dispatch({
        type: FETCH_USER_CVS_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_USER_CVS_FAILED,
        payload: error,
      });
    });
};
